import { bindActionCreators } from "redux";

import * as agent from "./agent";
import * as auth from "./authentication";
import * as campaign from "./campaigns";
import * as callFlow from "./cloudPBX/callFlow";
import * as clickToCall from "./cloudPBX/clickToCall";
import * as extension from "./cloudPBX/extension";
import * as outbound from "./cloudPBX/outboundCall";
import * as partnerSwitchboard from "./cloudPBX/partnerSwitchboard";
import * as phoneNumber from "./cloudPBX/phoneNumber";
import * as workTime from "./cloudPBX/workTime";
import * as account from "./miniCrm/account";
import * as article from "./miniCrm/article";
import * as comment from "./miniCrm/comment";
import * as contact from "./miniCrm/contact";
import * as indastry from "./miniCrm/indastry";
import * as knowledgeBase from "./miniCrm/knowledgeBase";
import * as monitor from "./miniCrm/monitor";
import * as stage from "./miniCrm/stage";
import * as ticket from "./miniCrm/ticket";
import * as topic from "./miniCrm/topic";
import * as telesaleCall from "./telesale/call";
import * as call from "./telesale/call";
import * as form from "./telesale/form";
import * as question from "./telesale/question";
import * as user from "./user";

export const SNACKBAR_ON_CLOSE = "SNACKBAR_ON_CLOSE";

const initialState = {
  snackbar: {
    anchorOrigin: { vertical: "bottom", horizontal: "right" },
    variant: "success",
    open: false,
    message: "",
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SNACKBAR_ON_CLOSE:
      return {
        snackbar: {
          ...state.snackbar,
          open: false,
        },
      };

    case auth.LOGIN_ERROR:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action.error,
        },
      };
    case user.CHANGE_PROFILE_ERROR:
    case campaign.ADD_NEW_CAMPAIGN_ERROR:
    case campaign.EDIT_A_CAMPAIGN_ERROR:
    case campaign.DELETE_A_CAMPAIGN_ERROR:
    case campaign.GET_A_CAMPAIGN_DETAIL_ERROR:
    case campaign.CONFIG_CAMPAIGN_ERROR:
    case campaign.CAMPAIGN_CONFIG_ERROR:
    case campaign.RELOAD_CAMPAIGN_ERROR:
    case contact.ADD_NEW_CONTACT_ERROR:
    case contact.EDIT_A_CONTACT_ERROR:
    case contact.DELETE_A_CONTACT_ERROR:
    case contact.ADD_NEW_CONTACT_FILE_ERROR:
    case contact.EDIT_A_CONTACT_FILE_ERROR:
    case contact.DELETE_A_CONTACT_FILE_ERROR:
    case contact.UPLOAD_CONTACT_FILE_ERROR:
    case agent.EDIT_A_AGENT_ERROR:
    case agent.DELETE_A_AGENT_ERROR:
    case agent.ADD_NEW_AGENT_GROUP_ERROR:
    case agent.EDIT_A_AGENT_GROUP_ERROR:
    case agent.DELETE_A_AGENT_GROUP_ERROR:
    case agent.CHANGE_STATUS_ERROR:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action?.error,
        },
      };
    case agent.ADD_NEW_AGENT_ERROR:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action?.error?.response?.data?.error?.message,
        },
      };
    case agent.END_ACTIVE_CALL_ERROR:
    case account.ADD_NEW_ACCOUNT_ERROR:
    case account.EDIT_A_ACCOUNT_ERROR:
    case account.DELETE_A_ACCOUNT_ERROR:
    case indastry.ADD_NEW_INDASTRY_ERROR:
    case indastry.EDIT_A_INDASTRY_ERROR:
    case indastry.DELETE_A_INDASTRY_ERROR:
    case stage.ADD_NEW_STAGE_ERROR:
    case stage.EDIT_A_STAGE_ERROR:
    case stage.DELETE_A_STAGE_ERROR:
    case form.ADD_NEW_FORM_ERROR:
    case form.EDIT_A_FORM_ERROR:
    case form.DELETE_A_FORM_ERROR:
    case question.ADD_NEW_QUESTION_ERROR:
    case question.EDIT_A_QUESTION_ERROR:
    case question.DELETE_A_QUESTION_ERROR:
    case extension.DELETE_EXTENSION_ERROR:
    case extension.EDIT_EXTENSION_ERROR:
    case extension.ADD_EXTETNSION_ERROR:
    case telesaleCall.MAKE_A_CALL_ERROR:
    case telesaleCall.ADD_NOTE_TO_CALL_ERROR:
    case knowledgeBase.ADD_NEW_KNOWLEDGE_BASE_ERROR:
    case knowledgeBase.EDIT_A_KNOWLEDGE_BASE_ERROR:
    case knowledgeBase.DELETE_A_KNOWLEDGE_BASE_ERROR:
    case topic.ADD_NEW_TOPIC_ERROR:
    case topic.EDIT_A_TOPIC_ERROR:
    case topic.DELETE_A_TOPIC_ERROR:
    case article.ADD_NEW_ARTICLE_ERROR:
    case article.EDIT_A_ARTICLE_ERROR:
    case article.DELETE_A_ARTICLE_ERROR:
    case comment.ADD_NEW_COMMENT_ERROR:
    case comment.EDIT_A_COMMENT_ERROR:
    case comment.DELETE_A_COMMENT_ERROR:
    case outbound.ADD_NOTE_OUTBOUND_CALL_ERROR:
    case telesaleCall.UPDATE_INTERACTIVE_LOG_ERROR:
    case telesaleCall.CHANGE_STATE_INTERACTIVE_LOG_ERROR:
    case telesaleCall.EDIT_INTERACTIVE_EDIT_ERROR:
    case monitor.SPY_CALL_ERROR:
    case clickToCall.CLICK_TO_CALL_ERROR:
    case telesaleCall.ADD_NEW_CUSTOMER_ERROR:
    case phoneNumber.EDIT_NUMBER_ERROR:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: "Vui lòng kiểm tra lại",
        },
      };
    case user.CHANGE_PASSWORD_SUCCESS:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "success",
          open: true,
          message: "Thay đổi mật khẩu thành công",
        },
      };
    case user.CHANGE_PROFILE_SUCCESS:
    case campaign.ADD_NEW_CAMPAIGN_SUCCESS:
    case campaign.EDIT_A_CAMPAIGN_SUCCESS:
    case campaign.DELETE_A_CAMPAIGN_SUCCESS:
    case campaign.GET_A_CAMPAIGN_DETAIL_SUCCESS:
    case campaign.CONFIG_CAMPAIGN_SUCCESS:
    case campaign.RELOAD_CAMPAIGN_SUCCESS:
    case contact.ADD_NEW_CONTACT_SUCCESS:
    case contact.EDIT_A_CONTACT_SUCCESS:
    case contact.DELETE_A_CONTACT_SUCCESS:
    case contact.ADD_NEW_CONTACT_FILE_SUCCESS:
    case contact.EDIT_A_CONTACT_FILE_SUCCESS:
    case contact.DELETE_A_CONTACT_FILE_SUCCESS:
    case contact.UPLOAD_CONTACT_FILE_SUCCESS:
    case agent.ADD_NEW_AGENT_SUCCESS:
    case agent.EDIT_A_AGENT_SUCCESS:
    case agent.DELETE_A_AGENT_SUCCESS:
    case agent.ADD_NEW_AGENT_GROUP_SUCCESS:
    case agent.EDIT_A_AGENT_GROUP_SUCCESS:
    case agent.DELETE_A_AGENT_GROUP_SUCCESS:
    case agent.CHANGE_STATUS_SUCCESS:
    case agent.END_ACTIVE_CALL_SUCCESS:
    case account.ADD_NEW_ACCOUNT_SUCCESS:
    case account.EDIT_A_ACCOUNT_SUCCESS:
    case account.DELETE_A_ACCOUNT_SUCCESS:
    case indastry.ADD_NEW_INDASTRY_SUCCESS:
    case indastry.EDIT_A_INDASTRY_SUCCESS:
    case indastry.DELETE_A_INDASTRY_SUCCESS:
    case stage.ADD_NEW_STAGE_SUCCESS:
    case stage.EDIT_A_STAGE_SUCCESS:
    case stage.DELETE_A_STAGE_SUCCESS:
    case form.ADD_NEW_FORM_SUCCESS:
    case form.EDIT_A_FORM_SUCCESS:
    case form.DELETE_A_FORM_SUCCESS:
    case question.ADD_NEW_QUESTION_SUCCESS:
    case question.EDIT_A_QUESTION_SUCCESS:
    case question.DELETE_A_QUESTION_SUCCESS:
    case extension.DELETE_EXTENSION_SUCCESS:
    case extension.EDIT_EXTENSION_SUCCESS:
    case extension.ADD_EXTETNSION_SUCCESS:
    case telesaleCall.MAKE_A_CALL_SUCCESS:
    case telesaleCall.ADD_NOTE_TO_CALL_SUCCESS:
    case knowledgeBase.ADD_NEW_KNOWLEDGE_BASE_SUCCESS:
    case knowledgeBase.EDIT_A_KNOWLEDGE_BASE_SUCCESS:
    case knowledgeBase.DELETE_A_KNOWLEDGE_BASE_SUCCESS:
    case topic.ADD_NEW_TOPIC_SUCCESS:
    case topic.EDIT_A_TOPIC_SUCCESS:
    case topic.DELETE_A_TOPIC_SUCCESS:
    case article.ADD_NEW_ARTICLE_SUCCESS:
    case article.EDIT_A_ARTICLE_SUCCESS:
    case article.DELETE_A_ARTICLE_SUCCESS:
    case comment.ADD_NEW_COMMENT_SUCCESS:
    case comment.EDIT_A_COMMENT_SUCCESS:
    case comment.DELETE_A_COMMENT_SUCCESS:
    case outbound.ADD_NOTE_OUTBOUND_CALL_SUCCESS:
    case telesaleCall.UPDATE_INTERACTIVE_LOG_SUCCESS:
    case telesaleCall.CHANGE_STATE_INTERACTIVE_LOG_SUCCESS:
    case telesaleCall.EDIT_INTERACTIVE_EDIT_SUCCESS:
    case telesaleCall.ADD_NEW_CUSTOMER_SUCCESS:
    case monitor.SPY_CALL_SUCCESS:
    case clickToCall.CLICK_TO_CALL_SUCCESS:
    case ticket.ADD_TICKET_SUCCESS_NOTI:
    case phoneNumber.EDIT_NUMBER_SUCCESS:
    case partnerSwitchboard.ADD_PARTNER_SWITCHBOARD_SUCCESS:
    case partnerSwitchboard.EDIT_PARTNER_SWITCHBOARD_SUCCESS:
    case callFlow.ADD_CALLFLOW_SUCCESS:
    case callFlow.EDIT_CALLFLOW_SUCCESS:
    case workTime.ADD_WORKTIME_SUCCESS:
    case workTime.EDIT_WORKTIME_SUCCESS:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "success",
          open: true,
          message: "Thực hiện thành công",
        },
      };
    case ticket.UPDATE_TICKET_SUCCESS_NOTI:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "success",
          open: true,
          message: "Thực hiện thành công",
        },
      };
    case ticket.UPDATE_TICKET_ERROR_NOTI:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action.error ? action.error : "Cập nhật ticket thất bại",
        },
      };
    case ticket.ADD_TICKET_ERROR_NOTI:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action.error ? action.error : "Thêm mới ticket thất bại",
        },
      };
    case ticket.ADD_NEW_TICKET_SUCCESS:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "success",
          open: true,
          message: "Thực hiện thành công",
        },
      };
    case ticket.UPDATE_TICKET_SUCCESS:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "success",
          open: true,
          message: "Thực hiện thành công",
        },
      };
    case ticket.UPDATE_TICKET_ERROR:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action.error ? action.error : "Cập nhật ticket thất bại",
        },
      };
    case ticket.ADD_NEW_TICKET_ERROR:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action.error ? action.error : "Thêm mới ticket thất bại",
        },
      };
    case call.UPDATE_LIST_INTERACTIVELOG:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "success",
          open: true,
          message: "Thực hiện thành công",
        },
      };

    case user.CHANGE_PASSWORD_ERROR:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action.error ? action.error : "Thay đổi mật khẩu thất bại",
        },
      };
    case agent.NO_PHONE_NUMBER_CANT_CALL:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action.error ? action.error : "Vui lòng chọn máy lẻ!",
        },
      };
    case agent.NO_STATUS_AGENT_CANT_CALL:
      return {
        snackbar: {
          ...state.snackbar,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
          variant: "warning",
          open: true,
          message: action.error
            ? action.error
            : "Vui lòng chọn trạng thái sẵn sàng gọi ra!",
        },
      };
    default:
      return state;
  }
};

export const closeSnackbar = () => ({
  type: SNACKBAR_ON_CLOSE,
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeSnackbar,
    },
    dispatch
  );
};
